import { render, staticRenderFns } from "./pool.vue?vue&type=template&id=08de8e01&scoped=true&"
import script from "./pool.vue?vue&type=script&lang=js&"
export * from "./pool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08de8e01",
  null
  
)

export default component.exports